export default __webpack_public_path__ + "static/en-4-738712d7946d696293f611f9ae269340.svg";